import { createIcon } from './factory'
import Icon from './sidebar-simple.svg?react'

export const SidebarSimple = createIcon({
  regular: Icon,
  bold: Icon,
  fill: Icon,
  duotone: Icon,
})
